import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Input from './input'

type InputFileSelectProps = {
    label: string
    required: boolean
    error?: { key: string; values: object }
    value: File | null
    onChange: (file: File | null) => void
    disabled?: boolean
}

const allowedFileExtensions = '.pdf, .jpg, .png'

const InputFileSelect = ({ label, required, error, value, disabled, onChange }: InputFileSelectProps) => {
    return (
        <Input label={label} error={error} required={required}>
            <div className="relative ">
                <label htmlFor="file_input" className="file-input overflow-hidden ">
                    <span className="leading-[29px] text-sm">{value ? value.name : 'Auswahl'}</span>
                </label>
                <FontAwesomeIcon
                    icon={['fas', 'xmark']}
                    className="absolute right-px top-1 text-sm p-2 cursor-pointer bg-white"
                    onClick={() => onChange(null)}
                />
            </div>
            {
                <input
                    className="hidden"
                    id="file_input"
                    type="file"
                    onChange={(event) => {
                        const selectedFile = event.target.files?.[0] || null
                        onChange(selectedFile)
                    }}
                    disabled={disabled}
                    accept={allowedFileExtensions}
                />
            }
        </Input>
    )
}

export default InputFileSelect
